import { useState } from "react";
import { api, useApi } from "../lib/api";
import { Badge, Button, Card, Empty, ErrorNote, fmtDate, Loading, useAction } from "../components/ui";

export default function Learning() {
  const { data, error, loading, reload } = useApi<any[]>("/rules");
  const act = useAction();
  const [msg, setMsg] = useState<string | null>(null);
  if (loading && !data) return <Loading />;
  const proposed = (data ?? []).filter((r) => r.status === "proposed");
  const decided = (data ?? []).filter((r) => r.status !== "proposed" && r.source === "learned");
  const decide = (id: string, accept: boolean) => act.run(async () => { await api(`/rules/${id}/decide`, { body: { accept } }); reload(); });
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-[1.45rem] font-semibold tracking-tight">Learning</h1>
        <Button onClick={() => act.run(async () => { const r = await api("/learning/run", { body: {} }); setMsg(r.proposed ? `${r.proposed} rule(s) proposed` : r.reason ?? "No new rules"); reload(); })} disabled={act.busy}>
          {act.busy ? "Studying edits…" : "Propose rules now"}
        </Button>
      </div>
      <p className="text-sm text-muted">Every 25 edits (or weekly) Claude studies how reps changed drafts and proposes writing rules. Accepted rules feed the next drafts and the style check.</p>
      <ErrorNote error={error ?? act.error} />
      {msg && <div className="text-sm text-muted">{msg}</div>}
      <Card title={`Proposed rules (${proposed.length})`}>
        {!proposed.length ? <Empty>Nothing proposed right now.</Empty> : (
          <ul className="space-y-3">
            {proposed.map((r) => (
              <li key={r.id} className="rounded-lg border border-warn/30 bg-warn-soft p-3">
                <div className="font-medium">{r.text}</div>
                <div className="mt-1 text-xs text-muted">{r.scope === "rep" ? "Per-rep" : "Team-wide"} · {r.evidence} · {fmtDate(r.createdAt)}</div>
                {r.banned?.length > 0 && <div className="mt-1 text-xs">Will warn on: {r.banned.map((b: string) => `“${b}”`).join(", ")}</div>}
                <div className="mt-2 flex gap-2">
                  <Button tone="primary" onClick={() => decide(r.id, true)}>Accept</Button>
                  <Button onClick={() => decide(r.id, false)}>Reject</Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
      <Card title="Decided">
        {!decided.length ? <Empty>None yet.</Empty> : (
          <ul className="space-y-1 text-sm">
            {decided.map((r) => <li key={r.id} className="flex items-center gap-2"><Badge>{r.status}</Badge>{r.text}<span className="text-xs text-muted">by {r.decidedBy}</span></li>)}
          </ul>
        )}
      </Card>
    </div>
  );
}
